import * as React from 'react'

import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import type { HeadCell } from 'modules/core/components/DataTable/types'
import i18n from 'modules/core/lib/i18n'

interface Props<T, S extends string> {
  kind: 'projections' | 'data'
  header: HeadCell<S>[]
  emptyState?: React.ReactNode
  selectable?: (item: T) => boolean
}

function Wrapper({ colSpan, children }: { colSpan: number; children: React.ReactNode }) {
  return (
    <Table.Body>
      <Table.Row>
        <Table.Cell colSpan={colSpan}>
          <Box
            width="full"
            paddingX="s32"
            paddingY="s64"
            flexDirection="column"
            gap="s16"
            alignItems="center"
            justifyContent="center"
          >
            {children}
          </Box>
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  )
}

function EmptyState<T, S extends string>({ header, emptyState, kind, selectable }: Props<T, S>) {
  const colSpan =
    header.reduce((acc, { colSpan }) => acc + (colSpan ?? 1), 0) + (selectable ? 1 : 0)

  return (
    <Wrapper colSpan={colSpan}>
      {emptyState ??
        (kind === 'projections' ? (
          <>
            <Icon.Large icon="browser-edit" color="grey600" />
            <Box flexDirection="column" gap="s4" alignItems="center">
              <Text.Header2>{i18n.t('data_table.empty_state.projections.title')}</Text.Header2>
              <Text.Normal color="grey800">
                {i18n.t('data_table.empty_state.projections.description')}
              </Text.Normal>
            </Box>
          </>
        ) : (
          <>
            <Icon.Large icon="document-folder-drawer-2" color="grey600" />
            <Box flexDirection="column" gap="s4" alignItems="center">
              <Text.Header2>{i18n.t('data_table.empty_state.data.title')}</Text.Header2>
              <Text.Normal color="grey800">
                {i18n.t('data_table.empty_state.data.description1')}
              </Text.Normal>
              <Text.Normal color="grey800">
                {i18n.t('data_table.empty_state.data.description2')}
              </Text.Normal>
            </Box>
          </>
        ))}
    </Wrapper>
  )
}

export default EmptyState
